/**
 * カレンダーの種別フィルタ
 *
 * 種別ごとのチップを押して表示・非表示を切り替える。選択は localStorage に残る。
 */

import { cn } from '@/lib/utils'

import { CALENDAR_FILTER_ITEMS, useCalendarFilterStore } from '../use-calendar-filter'

export const CalendarFilterBar = () => {
  const hiddenTypes = useCalendarFilterStore((state) => state.hiddenTypes)
  const toggleType = useCalendarFilterStore((state) => state.toggleType)
  const showAll = useCalendarFilterStore((state) => state.showAll)

  return (
    <div className="flex min-w-0 flex-1 items-center gap-1.5 overflow-x-auto px-2 py-1.5">
      {CALENDAR_FILTER_ITEMS.map(({ type, label, emoji }) => {
        const isHidden = hiddenTypes.includes(type)
        return (
          <button
            key={type}
            type="button"
            onClick={() => toggleType(type)}
            aria-pressed={!isHidden}
            className={cn(
              'shrink-0 rounded-full border px-2.5 py-1 text-xs whitespace-nowrap transition-colors',
              isHidden
                ? 'border-border text-muted-foreground bg-transparent'
                : 'border-transparent bg-secondary text-secondary-foreground',
            )}
          >
            {emoji} {label}
          </button>
        )
      })}

      {hiddenTypes.length > 0 && (
        <button
          type="button"
          onClick={showAll}
          className="text-muted-foreground shrink-0 px-2 py-1 text-xs whitespace-nowrap underline"
        >
          全部表示
        </button>
      )}
    </div>
  )
}
